// extracted by mini-css-extract-plugin
module.exports = {"content-requirments-wrapper":"ContentRequirments_content-requirments-wrapper__FbrIJ"};